/**
树形结构组件
author: 胡靖伟
**/
<template>
  <el-select
    :value="valueTitle"
    :clearable="clearable"
    @clear="clearHandle"
    popper-class="select-tree"
    :disabled="disabled"
    ref="selects"
    :size="size || 'medium'"
  >
    <el-option :value="valueTitle" :label="valueTitle" class="options" v-show="isShowOption">
      <el-tree
        id="tree-option"
        ref="selectTree"
        :accordion="accordion"
        :data="options"
        :props="props"
        :node-key="props.value"
        :default-expanded-keys="defaultExpandedKey"
        @node-click="handleNodeClick"
      ></el-tree>
    </el-option>
  </el-select>
</template>

<script>
export default {
  name: "selectTree",
  props: {
    size: String,
    disabled: Boolean,
    // 配置项
    props: {
      type: Object,
      default: {
        value: "id", // ID字段名
        label: "title", // 显示名称
        children: "children", // 子级字段名
      },
    },

    // 选项列表数据(树形结构的对象数组)
    options: {
      type: Array,
      default: [],
    },

    // 初始值
    value: {},

    // 可清空选项
    clearable: {
      type: Boolean,
      default: true,
    },

    // 自动收起
    accordion: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      valueId: null,
      valueTitle: "",
      defaultExpandedKey: [],
      isShowOption: true,
    };
  },
  mounted() {
    var _this = this;
    this.valueId = this.value; // 初始值
  },
  methods: {
    // 初始化值
    initHandle() {
      if (this.valueId) {
        if (this.$refs.selectTree.getNode(this.valueId) != null) {
          this.valueTitle = this.$refs.selectTree.getNode(this.valueId).data[
            this.props.label
          ]; // 初始化显示

          this.$refs.selectTree.setCurrentKey(this.valueId); // 设置默认选中
          this.defaultExpandedKey = [this.valueId]; // 设置默认展开
          this.initScroll();
        }
      }
    },
    // 初始化滚动条
    initScroll() {
      this.$nextTick(() => {
        let scrollWrap = document.querySelectorAll(
          ".el-scrollbar .el-select-dropdown__wrap"
        )[0];
        let scrollBar = document.querySelectorAll(
          ".el-scrollbar .el-scrollbar__bar"
        );
        scrollWrap.style.cssText =
          "margin: 0px; max-height: none; overflow: hidden;";
        scrollBar.forEach((ele) => (ele.style.width = 0));
      });
    },
    // 切换选项
    handleNodeClick(node) {
      if (node.childNodes != null && node.childNodes.length == 0) {
        this.$refs.selects.blur();
      }
      this.valueTitle = node[this.props.label];
      this.valueId = node[this.props.value];
      this.$emit("getValue", this.valueId);
      // if (node.childNodes.length==0){
      this.$emit("getAllValue", node);
      // }else{
      //   this.$emit('getAllValue',node.childNodes)
      // }
      this.defaultExpandedKey = [];
    },
    // 清除选中
    clearHandle() {
      this.valueTitle = "";
      this.valueId = null;
      this.defaultExpandedKey = [];
      this.clearSelected();
      this.$emit("getValue", null);
    },
    // 清空选中样式
    clearSelected() {
      let allNode = document.querySelectorAll("#tree-option .el-tree-node");
      allNode.forEach((element) => element.classList.remove("is-current"));
    },
  },
  watch: {
    value() {
      this.valueId = this.value;
      this.initHandle();
    },
    valueId() {
      this.initHandle();
    },
    // 树形列表数据
    options() {
      this.$nextTick(function () {
        // 初始化值
        this.initHandle();
      });
    },
  },
};
</script>

<style scoped>
.el-scrollbar .el-scrollbar__view .el-select-dropdown__item {
  height: auto;
  max-height: 260px;
  padding: 0;
  overflow: hidden;
  overflow-y: auto;
}
.el-select-dropdown__item.selected {
  font-weight: normal;
}
ul li >>> .el-tree .el-tree-node__content {
  height: auto;
  padding: 0 20px;
}
.el-tree-node__label {
  font-weight: normal;
}
.el-tree >>> .is-current .el-tree-node__label {
  color: #409eff;
  font-weight: 700;
}
.el-tree >>> .is-current .el-tree-node__children .el-tree-node__label {
  color: #606266;
  font-weight: normal;
}
/* 开发禁用 */
/* .el-tree-node:focus>.el-tree-node__content{
    background-color:transparent;
    background-color: #f5f7fa;
    color: #c0c4cc;
    cursor: not-allowed;
  }
  .el-tree-node__content:hover{
    background-color: #f5f7fa;
  } */
</style>



// WEBPACK FOOTER //
// src/components/commonUI/selectTree.vue